import { useState, useEffect } from 'react'
import { Grid } from "@mui/material"
import { ISettingsItem, useSettings } from '../../../Settings'
import { useTranslation } from '../../../i18n'

export default function Timer({ name }: ISettingsItem) {
  const { isSurfMVNE } = useSettings()
  const { t } = useTranslation()
  const [hours, setHours] = useState(24)
  const [minutes, setMinutes] = useState(0)
  const [seconds, setSeconds] = useState(0)

  useEffect(() => {
    let interval: NodeJS.Timeout

    const updateTime = () => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      } else {
        if (minutes > 0) {
          setMinutes(minutes - 1)
          setSeconds(59)
        } else {
          if (hours > 0) {
            setHours(hours - 1)
            setMinutes(59)
            setSeconds(59)
          } else {
            resetTimerFunc()
          }
        }
      }
    }

    const resetTimerFunc = () => {
      setHours(24)
      setMinutes(0)
      setSeconds(0)
    }

    interval = setInterval(updateTime, 1000)

    return () => clearInterval(interval)
  }, [hours, minutes, seconds])

  return (
    <Grid container item className={name ? `${name} timer` : "timer"} xs={12}>
      <Grid item className="timerArea timerTextArea" xs={7} md={8}>
        <h3>{t.page1.timer.limitedTime}</h3>
        {/* Para MVNEs Surf não mostrar mensagem de ganho de GB */}
        {!isSurfMVNE && <p>{t.page1.timer.gainBonus}</p>}
      </Grid>
      <Grid item className="timerArea" xs={5} md={4}>
        <div className="squareTime hours">{String(hours).padStart(2, "0")}</div>
        :
        <div className="squareTime minutes">{String(minutes).padStart(2, "0")}</div>
        :
        <div className="squareTime seconds">{String(seconds).padStart(2, "0")}</div>
      </Grid>
    </Grid>
  )
}